// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import message from 'antd/lib/message';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import Button from 'components/common/Button';
import AdminHeader from 'components/common/AdminHeader';
import InviteForm from 'components/forms/InviteForm';
import AdminUsersTable from './AdminUsersTable';
// APOLLO
import getUsersQuery from 'ApolloClient/Queries/getUsers';
import createUser from 'ApolloClient/Mutations/createUser';
import { compose, graphql } from 'react-apollo';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';
import ErrorHelpers from 'lib/helpers/ErrorHelpers';

class AdminUsers extends React.PureComponent {
  state = {
    showAddUserForm: false,
    loading: false,
  }

  toggleForm = () => {
    this.setState({ showAddUserForm: !this.state.showAddUserForm });
  };

  handleSubmit = ({ email, firstName, lastName, organizationId }) => {
    const params = { email, firstName, lastName, organizationId };
    this.setState({ loading: true });
    this.props.createUser({
      variables: { params },
    })
    .then(() => {
      this.setState({ loading: false, showAddUserForm: false });
      message.success('user created successfully!');
      window.location.reload();
    })
    .catch(err => ErrorHelpers.handleError(err))

  }

  render() {
    return (
      <PageContainer>
        <React.Fragment>
          {!this.state.showAddUserForm ? (
            <React.Fragment>
              <AdminHeader header="Users" action={<Button style={{marginBottom: 20}} onClick={this.toggleForm}>+ New User</Button>} />
              <div>
                <AdminUsersTable users={this.props.getUsersQuery.getUsers} />
              </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
              <AdminHeader header="Add New User" action={<Button type="dashed" style={{marginBottom: 20}} onClick={this.toggleForm}>Close</Button>} />
              <div>
                <InviteForm handleSubmit={this.handleSubmit} loading={this.state.loading} />
              </div>
              </React.Fragment>
            )}
          
        </React.Fragment>
      </PageContainer>
    );
  }
}

export default compose(
  graphql(createUser, { name: 'createUser' }),
  graphql(getUsersQuery, { name: 'getUsersQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'getUsersQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'getUsersQuery' }),
)(AdminUsers);



// WEBPACK FOOTER //
// ./src/routes/admin-users/index.js